var link_viewer_default = {
  "fontElementMap": "FMDf9",
  "link": "WAzZp",
  "linkInEditor": "y-zUt",
  "linkInViewer": "aiPD3",
  "toolbarUrlContainer": "N1RdL",
  "toolbarUrl": "MkRJO",
  "toolbarUrlAnchor": "KS16D"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
